<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
        <div class="d-flex flex-row justify-content-between w-100">
            <a class="navbar-brand" href="javascript:void(0)">Player Level Management</a>
            <a class="btn btn-sm btn-primary" [routerLink]="['/lo', company_uuid, 'setting-player-level', 'form']">&#43; Add Player Level</a>      
        </div>
    </div>
</nav>
<hr/>
<div class="row">
    <app-table #table></app-table>
</div>